<section class="fcomp-history" *ngIf="shouldShow">
  <div class="fcomp-history__label">
    <i class="pi pi-history"></i>
    {{ 'FLEXI_COMPLIANCE.HISTORY.LABEL' | translate }}
  </div>
  <ul class="fcomp-history__chips">
    <li *ngFor="let row of visibleRows"
        class="fcomp-history__chip"
        [ngClass]="toneClass(row.smiley)"
        [class.is-current]="row.isCurrent"
        [class.is-selected]="row.id === selectedId"
        role="button"
        tabindex="0"
        (click)="select(row)"
        (keyup.enter)="select(row)"
        [attr.aria-pressed]="row.id === selectedId"
        [attr.title]="(row.isCurrent
            ? 'FLEXI_COMPLIANCE.HISTORY.BACK_TO_CURRENT'
            : 'FLEXI_COMPLIANCE.HISTORY.VIEW_THIS') | translate">
      <span class="fcomp-history__face">
        <i class="pi" [ngClass]="{
            'pi-face-smile': row.smiley === 'green',
            'pi-minus-circle': row.smiley === 'yellow',
            'pi-times-circle': row.smiley === 'red'
        }"></i>
      </span>
      <span class="fcomp-history__pct">{{ row.percentage }}%</span>
      <span class="fcomp-history__date" *ngIf="row.completedOn">
        {{ row.completedOn | date:'mediumDate' }}
      </span>
      <span class="fcomp-history__current-tag" *ngIf="row.isCurrent">
        {{ 'FLEXI_COMPLIANCE.HISTORY.CURRENT' | translate }}
      </span>
    </li>
  </ul>
</section>
